import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const adminQuotationApi = createApi({
  reducerPath: 'adminQuotationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API,
    prepareHeaders: (headers) => {
      const user = localStorage.getItem('hthUser');
      const token = user ? JSON.parse(user).token : null;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAdminQuoteList: builder.query({
      query: ({ id = 0, page = 0, size = 10 }) => ({
        url: `/api/admin/getAllQuote/${id}/${page}/${size}`,
        method: 'GET',
      }),
    }),
    getViewComments: builder.query({
      query: (id) => `/api/staff/view-comments/${id}`,
    }),
    addComments: builder.mutation({
      query: (newHotelData) => ({
        url: `/api/staff/comments/add`,
        method: "POST",
        body: newHotelData,
      }),
    }),
    adminRejectLead: builder.mutation({
      query: (id) => ({
        url: `/api/staff/reject-lead/${id}`,
        method: "PUT",
      }),
    }),
    getAllLinks: builder.query({
      query: (id) => `/api/staff/getLinks/${id}`,
    }),
    getAdminStaffList: builder.query({
      query: () => ({
        url: '/api/admin/getStaffList',
        method: 'GET',
      }),
    }),
    assignToStaff: builder.mutation({
      query: (payload) => ({
        url: '/api/admin/assignToStaff',
        method: 'POST',
        body: payload,
      }),
    }),
    searchQuotes: builder.query({
      query: ({ keyword = '', page = 0, size = 10 }) => ({
        url: `/api/admin/quoteSAdmin?keyword=${keyword}&page=${page}&size=${size}`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetAdminQuoteListQuery,
  useGetViewCommentsQuery,
  useSearchQuotesQuery,
  useAddCommentsMutation,
  useAdminRejectLeadMutation,
  useGetAllLinksQuery,
  useGetAdminStaffListQuery,
  useAssignToStaffMutation,
} = adminQuotationApi;
